import React from 'react';
import Feedback180Main from './Feedback180Main';

const FeedbackCultural = () => {
  // Redirecionando para o novo sistema Feedback 180º
  return <Feedback180Main />;
};

export default FeedbackCultural;
